import React, { useMemo } from 'react';
import Skeleton from '@df-mobile/skeleton';
import styles from './index.less';

function classNames(...names) {
  return names.filter((c) => c).join(' ');
}

// **************** 电影首页骨架屏 *****************
function Banner() {
  return (
    <div className={styles.banner}>
      <Skeleton.Image animation />
    </div>
  );
}
function Title() {
  return (
    <Skeleton.Image animation className={styles.title} />
  );
}
function DoubleTitle(props: {className?: string}) {
  return (
    <div className={classNames(styles.doubleTitle, props.className)}>
      <Skeleton.Image animation />
      <Skeleton.Image animation />
    </div>
  );
}
function TopItem() {
  return (
    <div className={styles.topItem}>
      <Skeleton.Image animation className={styles.topItem_img} />
      <Skeleton.Image animation className={classNames(styles.height_36, styles.margin_top_16)} />
    </div>
  );
}

function List(props: {count: number, comp: React.FunctionComponent, [key: string]: any}) {
  const {count, comp: Comp, ...others} = props;
  const arr = useMemo(() => new Array(count || 5).fill(null), []);
  return (
    <div {...others}>
      {arr.map((c, i) => (
        <Comp key={i}></Comp>
      ))}
    </div>
  );
}

function MovieItem() {
  return (
    <div className={classNames(styles.movieItem, styles.margin_horizontal_40)}>
      <Skeleton.Image animation className={styles.movieItem_img} />
      <div className={styles.movieItem_right}>
        <Skeleton.Image animation className={styles.height_36} />
        <Skeleton.Image animation className={classNames(styles.height_36, styles.margin_top_16)} />
        <Skeleton.Image animation className={classNames(styles.height_36, styles.movieItem_short)} />
      </div>
    </div>
  );
}

function Tag() {
  return (
    <Skeleton.Image animation className={styles.tag} />
  );
}
function CinemaItem() {
  return (
    <div className={classNames(styles.margin_horizontal_40)}>
      <Skeleton.Image animation className={styles.height_40} />
      <Skeleton.Image animation className={classNames(styles.height_32, styles.margin_top_20, styles.width_480)} />
      <List count={4} comp={Tag} className={classNames(styles.scrollX, styles.scrollX_gap_10, styles.margin_top_20)}></List>
    </div>
  );
}

export function HotSkeleton() {
  return (
    <>
      <Banner></Banner>
      <Title></Title>
      <List count={6} comp={TopItem} className={classNames(styles.scrollX, styles.padding_horizontal_40)}></List>
      <Title></Title>
      <List count={10} comp={MovieItem} className={styles.listY}></List>
    </>
  );
}

export function CinemaSkeleton() {
  return (
    <>
      <Banner></Banner>
      <DoubleTitle></DoubleTitle>
      <List count={20} comp={CinemaItem} className={styles.listY}></List>
    </>
  );
}
export function FutureSkeleton() {
  return (
    <>
      <Banner></Banner>
      <Title></Title>
      <List count={10} comp={MovieItem} className={styles.listY}></List>
    </>
  );
}

// **************** 电影详情页骨架屏 *****************
function Date() {
  return (
    <div className={styles.date}>
      <Skeleton.Image animation className={classNames(styles.height_36)} />
      <Skeleton.Image animation className={classNames(styles.height_24, styles.margin_top_8)} />
    </div>
  );
}
function DetailCinemaItem() {
  return (
    <div className={classNames(styles.margin_horizontal_40)}>
      <Skeleton.Image animation className={styles.height_40} />
      <Skeleton.Image animation className={classNames(styles.height_32, styles.margin_top_10, styles.width_480)} />
      <List count={4} comp={Tag} className={classNames(styles.scrollX, styles.scrollX_gap_10, styles.margin_top_10)}></List>
      <Skeleton.Image animation className={classNames(styles.height_32, styles.margin_top_10, styles.width_480)} />
    </div>
  );
}
export function MovieSkeleton() {
  return (
    <>
      <div className={styles.movie_bg} />
      <div className={styles.detailBG}>
        <div className={styles.margin_horizontal_30}>
          <div className={styles.flex}>
            <div className={styles.movie_logo} />
            <div className={classNames(styles.flex_fill_content, styles.flex, styles.flex_column, styles.margin_left_28)}>
              <Skeleton.Image animation className={classNames(styles.width_236, styles.height_40, styles.margin_top_30)} />
              <Skeleton.Image animation className={classNames(styles.height_32, styles.margin_top_20)} />
              <Skeleton.Image animation className={classNames(styles.width_304, styles.height_32, styles.margin_top_20)} />
              <Skeleton.Image animation className={classNames(styles.width_248, styles.height_32, styles.margin_top_20)} />
            </div>
          </div>
          <Skeleton.Image animation className={classNames(styles.height_32, styles.margin_top_40)} />
          <Skeleton.Image animation className={classNames(styles.height_32, styles.margin_top_10, styles.margin_right_80)} />
        </div>
        <List count={7} comp={Date} className={classNames(styles.scrollX, styles.scrollX_gap_30, styles.margin_left_30, styles.margin_top_74)}></List>
        <DoubleTitle className={styles.padding_top_42}></DoubleTitle>
        <List count={10} comp={DetailCinemaItem} className={styles.listY}></List>
      </div>
    </>
  );
}
export function MovieTabSkeletonTop() {
  return (
    <>
      <DoubleTitle className={styles.padding_top_42}></DoubleTitle>
    </>
  );
}
export function MovieTabSkeletonBottom() {
  return (
    <>
      <List count={20} comp={DetailCinemaItem} className={classNames(styles.listY, styles.fixZIndex)}></List>
    </>
  );
}

// **************** 影院详情页骨架屏 *****************
function CinemaDetailItem() {
  return (
    <div className={classNames(styles.cinemaDetailItem, styles.margin_left_24, styles.margin_right_26)}>
      <div className={styles.width_112}>
        <Skeleton.Image animation className={styles.height_32} />
        <Skeleton.Image animation className={classNames(styles.height_24, styles.margin_top_10)} />
      </div>
      <div className={styles.margin_left_20}>
        <Skeleton.Image animation className={classNames(styles.height_32, styles.width_324)} />
        <Skeleton.Image animation className={classNames(styles.height_24, styles.width_116, styles.margin_top_10)} />
      </div>
      <Skeleton.Image animation className={classNames(styles.height_32, styles.width_98, styles.margin_left_20)} />
      <Skeleton.Image animation className={classNames(styles.buyButton, styles.width_98, styles.margin_left_22)} />
    </div>
  );
}
export function CinemaDetailSkeleton() {
  return (
    <>
      <div className={classNames(styles.flex, styles.flex_center, styles.margin_top_20)}>
        <Skeleton.Image animation className={classNames(styles.height_40, styles.width_320)} />
      </div>
      <Skeleton.Image animation className={classNames(styles.height_40, styles.width_670, styles.margin_left_30, styles.margin_top_22)} />
      <Skeleton.Image animation className={classNames(styles.height_24, styles.width_480, styles.margin_left_30, styles.margin_top_10)} />
      <div className={classNames(styles.flex, styles.margin_left_30, styles.margin_top_10)}>
        <Skeleton.Image animation className={classNames(styles.height_24, styles.width_80)} />
        <Skeleton.Image animation className={classNames(styles.height_24, styles.width_80, styles.margin_left_10)} />
        <Skeleton.Image animation className={classNames(styles.height_24, styles.width_80, styles.margin_left_10)} />
        <Skeleton.Image animation className={classNames(styles.height_24, styles.width_80, styles.margin_left_10)} />
      </div>
      <div className={styles.cinemaDetailImage}>
        <div className={styles.cinemaDetailImage_top}>
          <div className={styles.image_left}></div>
          <div className={styles.image_middle}></div>
          <div className={styles.image_right}></div>
        </div>
        <Skeleton.Image animation className={classNames(styles.width_320, styles.height_40, styles.margin_top_20)} />
        <Skeleton.Image animation className={classNames(styles.width_480, styles.height_24, styles.margin_top_10)} />
      </div>
      <List count={7} comp={Date} className={classNames(styles.scrollX, styles.scrollX_gap_30, styles.margin_left_30, styles.padding_bottom_38, styles.margin_top_40)}></List>
      <List count={20} comp={CinemaDetailItem} className={classNames(styles.listY, styles.padding_top_12)}></List>
    </>
  );
}
export function CinemaDetailTabSkeleton() {
  return (
    <>
      <List count={20} comp={CinemaDetailItem} className={classNames(styles.listY, styles.fixZIndex, styles.padding_top_12)}></List>
    </>
  );
}
// ************************************************


